import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { PlayIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'next-i18next';

interface Props {
  run: () => void;
}

const RunTestsBtn: FunctionComponent<Props> = ({ run }) => {
  const { t } = useTranslation('common');

  return (
    <div className="flex mt-4 md:mt-0">
      <button
        className={classNames(
          'inline-block rounded-sm text-platzi-dark bg-platzi-green  duration-300 font-bold capitalize text-xs px-4 py-2  w-full  opacity-90 hover:opacity-100 cursor-pointer'
        )}
        type="button"
        onClick={() => run()}
      >
        <span className="flex space-x-2 items-center justify-center">
          <PlayIcon className="h-5 w-5" />
          <span>{t('codeRunner.run')}</span>
        </span>
      </button>
    </div>
  );
};

export default RunTestsBtn;
